import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var CaretDown = function CaretDown(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#4C5165' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.6rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Caret down icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 16 16",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M8.68645 11.6739C8.32433 12.1087 7.67567 12.1087 7.31355 11.6739L2.2234 5.56238C1.71407 4.95085 2.13184 4 2.90985 4L13.0901 4C13.8682 4 14.2859 4.95085 13.7766 5.56238L8.68645 11.6739Z",
    fill: color
  }));
};

export default CaretDown;